<template>
  <div id="select_wrap" :class="{ dark: !$store.state.isdark }">
    <div style="width: 240px" v-show="show">
      <ly-form-item label="选择车辆"
        ><select-car
          placement="left"
          :name="carNo"
          @update:name="carNo = $event"
          :deviceNo="deviceNo"
          @update:deviceNo="deviceNo = $event"
          @car="reCar"
          filterGroup="车辆"
        ></select-car
      ></ly-form-item>
      <ly-form-item label="快速选择"
        ><Select v-model="day" @on-change="selectGetDay">
          <Option
            v-for="(item, index) in dayList"
            :value="item.value"
            :key="index"
            >{{ item.label }}</Option
          >
        </Select></ly-form-item
      >
      <ly-form-item label="开始时间"
        ><DatePicker
          @on-change="datePickerChange"
          type="datetime"
          placement="bottom-end"
          placeholder="请输入时间信息"
          v-model="startTime"
          style="width: 100%"
          :clearable="false"
        ></DatePicker
      ></ly-form-item>
      <ly-form-item label="结束时间"
        ><DatePicker
          @on-change="datePickerChange"
          type="datetime"
          placement="bottom-end"
          placeholder="请输入时间信息"
          v-model="endTime"
          style="width: 100%"
          :clearable="false"
        ></DatePicker
      ></ly-form-item>
      <ly-form-item label="停车点" v-if="simble == undefined"
        ><Select
          :disabled="!showPark"
          @on-change="changeDuration"
          v-model="duration"
        >
          <Option
            v-for="item in parkLsit"
            :value="item.value"
            :key="item.value"
            v-show="item.value != 200"
            >{{ item.label }}</Option
          >
        </Select></ly-form-item
      >
      <ly-form-item label="报警点" v-if="simble == undefined">
        <i-switch v-model="showAlarm">
          <span slot="open">开</span>
          <span slot="close">关</span>
        </i-switch>
        <!-- <Button type="text" @click="showAlarmList">报警列表</Button> -->
      </ly-form-item>
      <Row :gutter="8" style="margin-top: 20px">
        <Col span="24"
          ><Button type="primary" long @click="clickBtn(0)"
            >查询轨迹</Button
          ></Col
        >
      </Row>
    </div>

    <Modal v-model="bengkui" title="查询时间超过7天" footer-hide width="400">
      <Form ref="item" :label-width="0">
        <Row :gutter="16">
          <Col span="24">
            <h2 style="margin-bottom: 10px; line-height: 1.8">
              数据量可能很庞大，继续查看会影响性能
            </h2>
          </Col>
        </Row>

        <Row type="flex" justify="end">
          <div class="btn-wrap">
            <Button @click="jixu">继续查看</Button>
            <Button type="primary" @click="bengkui = false">取消查看</Button>
          </div>
        </Row>
      </Form>
    </Modal>
  </div>
</template>
<script>
export default {
  props: ["isdark", "loucs", "simble"],

  data() {
    return {
      value2: false,
      show: true,
      bengkui: false,
      playStatus: 1, //播放状态
      hideFormat() {
        return null; //隐藏滑块标签
      },
      dayList: [
        {
          value: 0,
          label: "今天",
        },
        {
          value: 1,
          label: "昨天",
        },
        {
          value: 2,
          label: "前天",
        },
        {
          value: 3,
          label: "近三天",
        },
        {
          value: 7,
          label: "近七天",
        },
        {
          value: 200,
          label: "自定义",
        },
      ],
      day: 0,
      startTime: "",
      endTime: "",
      carNo: "",
      deviceNo: "",
      carTypeCateg: "",
      showPark: true,
      parkLsit: [
        {
          value: 1,
          label: "超过1分钟",
        },
        {
          value: 5,
          label: "超过5分钟",
        },
        {
          value: 10,
          label: "超过10分钟",
        },
        {
          value: 30,
          label: "超过30分钟",
        },
        {
          value: 60,
          label: "超过1小时",
        },
        {
          value: 120,
          label: "超过2小时",
        },
        {
          value: 240,
          label: "超过4小时",
        },
        {
          value: 99999999,
          label: "不显示",
        },
      ],
      duration: 1,
      showAlarm: false,
    };
  },
  methods: {
    reCar(v) {
      this.carTypeCateg = v.carTypeCateg;
    },
    xianzhi() {
      var ddd = {
        startTime: this.startTime,
        endTime: this.endTime,
        limit: 31,
      };
      if (this.carNo.length == 0) {
        this.$Message.error("请选择车辆");
        return false;
      } else if (!this.utils.jcTime(this, ddd)) {
        return false;
      } else {
        return true;
      }
    },
    //下拉快速选择日期
    selectGetDay(t) {
      var day = {
        200: { x: null, y: null },
        0: { x: 0, y: 0 },
        1: { x: -1, y: -1 },
        2: { x: -2, y: -2 },
        3: { x: -2, y: 0 },
        7: { x: -6, y: 0 },
      };
      var t1 = this.utils.days(day[t].x, day[t].y, false);

      this.startTime = new Date(t1.start);
      this.endTime = new Date(t1.end);
    },
    datePickerChange() {
      this.day = 200;
    },
    jixu() {
      this.$emit("history", {
        start: this.startTime,
        end: this.endTime,
        deviceNo: this.deviceNo,
        carNo: this.carNo,
        val: 0,
      });
      this.bengkui = false;
    },
    clickBtn(val) {
      if (this.xianzhi()) {
        var obj = {
          start: this.startTime,
          end: this.endTime,
          deviceNo: this.deviceNo,
          val: val,
          carNo: this.carNo,
          carTypeCateg: this.carTypeCateg,
        };
        if (val == 0) {
          //查看轨迹的时候如果超过7天
          var aaa = this.endTime.getTime() - this.startTime.getTime();

          if (this.xianzhi()) {
            if (aaa > 86400000 * 7 && aaa <= 86400000 * 30) {
              this.bengkui = true;
            } else {
              this.$emit("history", obj);
            }
          }
        } else {
          this.$emit("history", obj);
        }
      }
    },
    changePark() {
      this.$emit("park", this.showPark);
    },
    changeDuration() {
      this.$emit("parkDuration", this.duration);
    },
    changeAlarm() {
      this.$emit("alarmData", this.showAlarm);
    },
    showAlarmList() {
      this.$emit("showAlarmList");
    },
    resetTime(start,end){
      this.startTime=start;
      this.endTime=end;
    }
  },
  mounted() {
    this.selectGetDay(0);
  },
  computed: {
    carMsg() {
      var v = this.$store.state.carMsg;
      this.carNo = v.carNo;
      this.deviceNo = v.deviceNo;
      // return this.$store.state.carMsg;
    },
  },
  watch: {
    carMsg() {},
  },
};
</script>
<style lang="">
#select_wrap {
  background: #fff;
  color: #333;
  padding: 10px 20px 2px 20px;
  text-align: left;
  position: relative;
}
#select_wrap .ivu-form-item {
  margin-bottom: 6px;
}
#select_wrap .show {
  margin-bottom: 20px;
  position: absolute;
  right: 8px;
  top: 2px;
}
#select_wrap .show i:hover {
  color: #f63;
  cursor: pointer;
  top: 4px;
}
#select_wrap .ivu-row {
  margin-bottom: 20px;
}
#select_wrap .lyformitem label {
  margin-top: 8px;
}
/* 抽屉自定义样式 */
#select_wrap .ivu-drawer-header {
  display: none;
}
.dark {
  background: rgba(0, 0, 0, 0.5) !important;
  color: #fff !important;
}
.dark p,
.dark span,
.dark label {
  color: #fff !important;
}
.dark .ivu-col,
.dark span.ivu-select-selected-value {
  color: #fff !important;
}
.dark input {
  background: none;
  border-color: #666;
  color: #fff;
}
.dark .ivu-picker-panel-content {
  background: none;
  border-color: #666;
  color: #585858;
}
.dark .ivu-select-single .ivu-select-selection {
  background: none;
  border-color: #666;
  color: #fff;
}

#nowData .ivu-slider-bar {
  background: #fa8424;
}
.icon-select {
  margin-bottom: 10px;
}
.icon-select i {
  font-size: 1.7em;
  padding: 0.2em;
  border-radius: 1em;
  color: #1fadee;
  background: #e7f4fd;
  opacity: 1;
  margin-right: 8px;
  transition: background 0.1s, transform 0.6s, color 0.6s;
}
.icon-select i:hover {
  cursor: pointer;
  transform: rotate(360deg);
  background: #cae4f7;
  color: #1689be;
}
</style>


// WEBPACK FOOTER //
// src/components/locus/select.vue